module.exports = __webpack_public_path__ + "images/default_avatars/nightfall@2x-fd2c2534eecda05961f47702099736c1.jpg";